import cx from 'classnames';
import PropTypes from 'prop-types';
import { useFocused, useSelected } from 'slate-react';

import { VoidNodeContent } from '../VoidNodeContent';

import { useStyles } from './useStyles';

export const InstructionNode = ({ element, children, attributes }) => {
  const styles = useStyles();

  const selected = useSelected();
  const focused = useFocused();

  return (
    <span
      className={cx(styles.root, {
        [styles.highlighted]: selected && focused,
      })}
      {...attributes}
      data-node-type={element.type}
      contentEditable={false}
    >
      <VoidNodeContent text={element.children[0].text}>{children}</VoidNodeContent>
    </span>
  );
};

InstructionNode.propTypes = {
  attributes: PropTypes.shape({}),
  element: PropTypes.shape().isRequired,
  children: PropTypes.node,
};

InstructionNode.defaultProps = {
  attributes: {},
  children: null,
};
